import React from "react";
import { Container, LabelContainer } from "./DashboardDataTile.styles";
import UI from "@mile-meeting/mile-ui";
import ToolTip from "uis/new-tootip";

type DashboardDataTileProps = {
  label: string;
  value: string;
  subValue?: string;
  tooltip?: string | JSX.Element;
  width?: string;
  disabled?: boolean;
};
const DashboardDataTile: React.FC<DashboardDataTileProps> = ({
  label,
  value,
  tooltip,
  width = "100%",
  subValue,
  disabled = false,
}) => {
  return (
    <Container style={{ width }} disabled={disabled}>
      <LabelContainer>
        <UI.Typography
          type="body01 normal"
          color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-neutral)"}
        >
          {label}
        </UI.Typography>
        {disabled && <UI.Icon name="question" size={20} color="var(--alias-color-label-disabled)" />}
        {!disabled && tooltip && (
          <ToolTip
            text={tooltip}
            icon={"question"}
            position={label === "가장 적게 사용된 회의실" ? { left: -260, top: 24 } : { left: -40, top: 24 }}
          />
        )}
      </LabelContainer>
      <div style={{ gap: 4, display: "flex", flexDirection: "column" }}>
        {subValue && (
          <UI.Typography
            type="body01 normal"
            color={disabled ? "var(--alias-color-label-disabled" : "var(--alias-color-label-neutral)"}
            style={{ marginBottom: "4px" }}
          >
            {subValue}
          </UI.Typography>
        )}
        <UI.Typography
          type="heading02"
          fontStyle="bold"
          color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-strong)"}
        >
          {value}
        </UI.Typography>
      </div>
    </Container>
  );
};

export default React.memo(DashboardDataTile);
